import { useFetchTaskDetails } from "../../../../../../../../../../../../hooks/useFetchTaskDetails";
import css from "./AnalyticsRefDataResourceView.module.css";

type AnalyticsRefDataResourceViewProps = {
  downloadUrl: string;
  taskId: string;
};

export function AnalyticsRefDataResourceView(
  props: AnalyticsRefDataResourceViewProps
) {
  const { taskDetails, isFetchingTaskDetails } = useFetchTaskDetails({
    taskId: props.taskId,
    taskCache: { timeToLiveInSeconds: 60 },
  });

  if (isFetchingTaskDetails) {
    return <div>Loading...</div>;
  }

  if (taskDetails?.type === "video") {
    return <video
      style={{
        width: "100%",
        height: "auto",
        padding: "10px"
      }}
      controls
    src={props.downloadUrl} />;
  }

  if (taskDetails?.type === "image") {
    return (
      <img
        //@ts-ignore
        src={item.resourceSignedUrl}
        alt={`Image unable to render`}
        style={{ width: "100%", height: "auto", margin: "10px" }}
      />
    );
  }

  return <></>;

}
